/**
 * 获取url参数
 * @param name
 * @param includeHash 是否包含hash后面的参数检索
 */
export function getQueryString(name: string, includeHash = true) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
  const queryStr = window.location.search.slice(1);
  let r = queryStr.match(reg);

  if (includeHash && !r) {
    r = window.location.hash.split('?', 2)[1]?.match(reg);
  }

  if (r) {
    return window.decodeURIComponent(r[2]);
  }

  return '';
}

/**
 * 截取超过指定长度的字符串并在末尾添加省略号
 * @param str 要处理的字符串
 * @param maxLength 最大允许的字符串长度
 * @returns 如果字符串长度超过 maxLength，返回截取后的字符串加上 '...'；否则返回原字符串
 */
export function truncateString(str: string, maxLength: number): string {
  // 如果字符串长度小于或等于最大长度，直接返回
  if (str.length <= maxLength) {
    return str;
  }

  // 否则，截取字符串并添加省略号
  return `${str.slice(0, maxLength)}...`;
}
